// extracted by mini-css-extract-plugin
module.exports = {"deleted":"AdminsTable_deleted__3wKj9","actions":"AdminsTable_actions__ongYN"};